import React, { useState, useEffect } from 'react';
import { Bar } from 'react-chartjs-2';
import { useSelector } from 'react-redux';
import { fetchApi } from '../../utlis/axios';

import { Link } from "react-router-dom";
import { FiRefreshCcw } from "react-icons/fi";

const MedicationChart = () => {
  const { access } = useSelector((state) => state.authSlice.userInfo);
  const [medication, setMedication] = useState([]);
  const [refreshing, setRefreshing]=useState(false)

  useEffect(() => {
    getMedicationData();
  }, []); // Fetch data when the component mounts

  const getMedicationData = async () => {
    try {
      const result = await fetchApi.get('members-graph/', {
        headers: {
          Authorization: `Bearer ${access}`,
        },
      });

      if (result.status === 200) {
        const medicationDataResponse = result.data;
        const monthlyMedication = {};
        const currentYear = new Date().getFullYear();

        medicationDataResponse.forEach((medicationData) => {
          const createdDate = new Date(medicationData.created_at);
          const medicationYear = createdDate.getFullYear();

          if (medicationYear === currentYear && medicationData.permanent_medication === true) {
            const month = createdDate.toLocaleString('en-US', { month: 'long' });

            if (monthlyMedication[month]) {
              monthlyMedication[month]++;
            } else {
              monthlyMedication[month] = 1;
            }
          }
        });

        const allMonths = Array.from({ length: 12 }, (_, i) => {
          const monthName = new Date(null, i).toLocaleString('en-US', {
            month: 'long',
          });
          return {
            month: monthName,
            count: monthlyMedication[monthName] || 0,
          };
        });

        setMedication(allMonths);
      }
    } catch (error) {
      console.log({ error });
    }
  };

 async function handleRefresh(params) {
  setRefreshing(true)
  await getMedicationData()
  setRefreshing(false)
 }

  const data = {
      labels: medication.map((entry) => entry.label),
      datasets: [
        {
          type: "line",
          label: "Permanent Medication",
          data: medication.map((entry) => entry.count),
          fill: true, // important for gradient fill
          borderColor: "rgba(33, 157, 128, 1)", // solid border color
          borderWidth: 2,
          backgroundColor: (context) => {
            const chart = context.chart;
            const { ctx, chartArea } = chart;
    
            if (!chartArea) {
              return null; // return early if chart not yet rendered
            }
    
            // Create gradient
            const gradient = ctx.createLinearGradient(
              0,
              chartArea.top,
              0,
              chartArea.bottom
            );
            gradient.addColorStop(0, "rgba(33, 157, 128, 0.3)"); // top
            gradient.addColorStop(1, "rgba(33, 157, 128, 0.05)"); // bottom
            return gradient;
          },
        },
      ],
    };

  const options = {
    scales: {
      x: {
        type: 'category',
        beginAtZero: true,
      },
      y: {
        beginAtZero: true,
        precision: 0,
      },
    },
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 15,        
          usePointStyle: false,
          boxHeight: 15,   
          padding: 10,
          color: "#000",
          font: { 
            size: 14, 
            weight: "500",
            family:'roboto'       
          },
        },
      },
      
    },
  };

  return (
    <div className=' w-full bg-white sm:p-5 p-2.5 rounded-xl shadow md:mt-6 mt-4'>
             
                <div className='flex items-center justify-between gap-2'>
                <p style={{color:'black', fontSize:'20px'}} className='font-semibold mb-2'>
                 Permanent Medication
                  </p>
                  <span
          onClick={handleRefresh}
          disabled={refreshing}
          className={`p-2 w-max rounded-lg cursor-pointer !border-[2px] !border-[#D8D8D8] hover:bg-gray-50 transition bg-transparent shadow-none `}
        >
          <FiRefreshCcw
            className={`text-gray-600 text-lg ${
              refreshing ? "animate-spin" : ""
            }`}
          />
        </span>
                  </div>
                  <Link to='/memberdetailpage'>
    <div className='dashboard-responsive'>
      <Bar data={data} options={options} height={430}/>
    </div>
    </Link>
    </div>
    
  );
};

export default MedicationChart;